module.exports = __webpack_public_path__ + "static/media/competitiveprogramming.edeab740.png";